import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setOpen(false);
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Failed to update password");
    } finally {
      setBusy(false);
    }
  };

  const inpCls = "font-mono bg-black/50 border-border rounded-none focus:ring-1 focus:ring-white h-10";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="open-change-password" className="rounded-none font-mono text-xs hover:bg-secondary gap-2">
          <KeyRound className="w-3.5 h-3.5" /> Password
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-none bg-card border-border" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-mono text-sm">Change password</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label className="overline">Current password</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="current-password-input" className={inpCls} />
          </div>
          <div className="space-y-2">
            <Label className="overline">New password</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="new-password-input" className={inpCls} />
          </div>
          <div className="space-y-2">
            <Label className="overline">Confirm new password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="confirm-password-input" className={inpCls} />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="submit-change-password" className="rounded-none bg-white text-black hover:bg-white/90">
              {busy ? "Saving…" : "Update password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
